import { ConversationRole, Message } from 'src/types';

export const DEFAULT_THINKING_TEXT = 'Thinking...';

export const TEMPORARY_EMPTY_MESSAGE_ID = 'EMPTY_MESSAGE';

export const TEMPORARY_EMPTY_MESSAGE: Message = {
  message_id: TEMPORARY_EMPTY_MESSAGE_ID,
  content: '',
  role: ConversationRole.AGENT,
  user_id: '',
  from_user_id: '',
  to_user_id: '',
};
